import Axios from 'axios'
import {apiDomain} from './../.env.js'

export default function (Vue) {
  Axios.defaults.baseURL = apiDomain

  Vue.auth = {
    setToken (username, token) {
      localStorage.setItem('username', username)
      localStorage.setItem('token', token)

      Axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
      Axios.defaults.headers.post["Content-Type"] = "application/json"
    },
    getToken () {
      return localStorage.getItem('token')
    },
    setPermissions(permissions) {
      localStorage.setItem('permissions', permissions)
    },
    getPermissions() {
      const p = localStorage.getItem('permissions')
      return p?p.split(',').map(item => item.trim()):[]
    },
    destroyToken () {
      localStorage.removeItem('username')
      localStorage.removeItem('token')
      localStorage.removeItem('permissions')

      delete Axios.defaults.headers.common['Authorization']
    },
    isAuthenticated () {
      return !!this.getToken()
    }
  }

  const existingToken = localStorage.getItem('token')
  if (existingToken) {
    Axios.defaults.headers.common['Authorization'] = 'Bearer ' + existingToken
    Axios.defaults.headers.post["Content-Type"] = "application/json"
  }

  Object.defineProperties(Vue.prototype, {
    $auth: {
      get () {
        return Vue.auth
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/config/auth.js